// extracted by mini-css-extract-plugin
module.exports = {"notFoundWrapper":"spu2E72k7DR6fcbGT-cwM","notFoundLinks":"_3qPyhOJ5-3EDxDf5lfNyBu"};